import I18nHelper from '../../../myAccount/helper/i18n-helper';
export default {
  name: 'CoveoAiIcon',
  data: function () {
    return {
      coveoAiIcon: I18nHelper.getI18nMessage('coveo.ai.icon.alt.text')
    };
  }
};